import type { AuthContext } from "./_types";

import { createContext, useContext } from "react";

export const Context = createContext({} as AuthContext);

export const useAuthContext = () => useContext(Context);
